/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_No_Folder_SelectedInputs */

const en_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No folder selected`)
};

const fr_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun dossier sélectionné`)
};

const de_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ordner ausgewählt`)
};

const it_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna cartella selezionata`)
};

const ru_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папка не выбрана`)
};

const es_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna carpeta seleccionada`)
};

const zh_cn2_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择文件夹`)
};

const ja_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダが選択されていません`)
};

const hi_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई फ़ोल्डर चयनित नहीं है`)
};

const pt_pt2_options_backup_no_folder_selected = /** @type {(inputs: Options_Backup_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma pasta selecionada`)
};

/**
* | output |
* | --- |
* | "No folder selected" |
*
* @param {Options_Backup_No_Folder_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_no_folder_selected = /** @type {((inputs?: Options_Backup_No_Folder_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_No_Folder_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_no_folder_selected(inputs)
	if (locale === "de") return de_options_backup_no_folder_selected(inputs)
	if (locale === "it") return it_options_backup_no_folder_selected(inputs)
	if (locale === "ru") return ru_options_backup_no_folder_selected(inputs)
	if (locale === "es") return es_options_backup_no_folder_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_no_folder_selected(inputs)
	if (locale === "ja") return ja_options_backup_no_folder_selected(inputs)
	if (locale === "hi") return hi_options_backup_no_folder_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_no_folder_selected(inputs)
	return en_options_backup_no_folder_selected(inputs)
});